import { CommonCheckerToolApiError } from "@/components/pages/tool-components/shared/editor/types";

export type MatchObject = {
  id: string | number;
  value: string;
  isCorrect: boolean;
  message?: string;
  description?: string;
  replacements?: {
    value: string;
  }[];
  ruleId?: string;
  status?: string;
  isIgnored?: boolean;
};

export type TooltipState = {
  x: number | null;
  y: number | null;
  data?: MatchObject;
  isShown: boolean;
};

export type EditorState = {
  text: string;
  html: string | null;
  isChecked: boolean;
};
export const getRawObject = (object: MatchObject) => {
  if (object.isCorrect || object.isIgnored)
    return `<span id="${object.id}" class="editor-fragment">${object.value}</span>`;

  return `<span id="${object.id}" class="editor-fragment editor-highlight highlight-${object.status}">${object.value}</span>`;
};

export const getRawObjects = (objects: MatchObject[], disabledRules: string[]) => {
  if (!objects.length) return "";

  return objects.reduce((result, object) => {
    if (disabledRules.includes(object.ruleId || "")) object.isIgnored = true;

    return result + getRawObject(object);
  }, "");
};

type MatchItem = {
  rule: {
    id: string;
  };
  offset: number;
  length: number;
  message: string;
  replacements: {
    value: string;
  }[];
};

export const parseGrammarSpellCheckerMatches = (errors: CommonCheckerToolApiError[], text: string) => {
  const objects: MatchObject[] = [];
  let index = 0;

  errors.forEach((error) => {
    let matchStatus = "error",
      value = "";

    if (error.offset > index) {
      value = text.substring(index, error.offset);
      objects.push({ id: index, value, isCorrect: true });
    }

    value = text.substring(error.offset, error.offset + error.length);

    objects.push({
      id: error.offset,
      value,
      message: error.description.en,
      replacements: error.better.map((value) => ({ value })),
      ruleId: error.id,
      status: error.type === "spelling" ? "error" : "warning",
      isIgnored: false,
      isCorrect: false,
    });

    index = error.offset + error.length;
  });

  objects.push({ id: index, value: text.substring(index), isCorrect: true });

  return objects;
};
